import { Checkbox } from '@dealstack/frontend/shared/components/fundament/Checkbox/Checkbox';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import styled from 'styled-components';

export const TableCheckbox = styled(Checkbox)`
	padding: 0;
	${Icon}.svg {
		--size: 1.25rem;
	}
`;
